import user from "../User/Infrastructure/User.reducer";
import adviser from "../Adviser/Infrastructure/Adviser.reducer";
import businessPartner from "../BusinessPartner/Infrastructure/BusinessPartner.reducer";
import chat from "../Chat/Infrastructure/Chat.reducer";

const reducer = { user, adviser, businessPartner, chat };

export default reducer;
